import React, { MouseEventHandler } from "react";
import i18n from '../../i18n';
interface IButtonProps {
    handleClick: MouseEventHandler<HTMLAnchorElement>
    textButton: string
    isDisabled: boolean
    customClassName?: string
    dataTestId?: string
}

export const Button: React.FC<IButtonProps> = (ButtonProps: IButtonProps) => {
    const { handleClick, textButton, isDisabled, customClassName, dataTestId  } = ButtonProps

    return (
        <div className={`col-12 ${customClassName ? customClassName : null}`}>
         {/* eslint-disable-next-line */}
            <a href="#" className={`button ${isDisabled ? 'disabled' : ''}`} onClick={handleClick} data-testid={dataTestId}>
                {i18n.t(`${textButton}`)}
            </a>
        </div>
    );
}